import api from '@/api';

import {
  REST_LIST,
  SET_USER,
  GET_ACCOUNT_DATA,
  SEND_ACCOUNT_DATA,
} from './types';

export default {
  /**
   * Get list of restaurants
   *
   * @param {number} lat - latitude coordinate for filtering by distance
   * @param {number} lng - longitude coordinate for filtering by distance
   * @param {number} limit - max count of restaurants
   * @param {number} offset - offset for pagination
   * @returns {Promise}
   */
  [REST_LIST]: async ({ commit }, { lat, lng }) => {
    const resp = await api.desktop.listRestaurants({
      limit:   100,
      offset:  0,
      filters: {
        latitude:  lat,
        longitude: lng,
      },
    });

    commit(REST_LIST, resp.data.results);

    return resp;
  },
  /**
   * Get the user data.
   */
  [GET_ACCOUNT_DATA]: async ({ commit }) => {
    const resp = await api.desktop.userData();

    commit(SET_USER, resp.data);

    return resp;
  },
  /**
   * Send the user data (create or update account).
   */
  [SEND_ACCOUNT_DATA]: async ({ dispatch, getters }, { user, updated }) => {
    const { isGuest, isAuthenticated } = getters;
    const userToBackend = {};
    const fieldsNameMap = {
      firstName: 'first_name',
      lastName:  'last_name',
      email:     'email',
      address:   'address',
      city:      'city',
      state:     'state',
      zip:       'zip',
      birthday:  'birthday',
      password:  'password',
      phone:     'phone',
    };

    Object.keys(user).forEach((fieldName) => {
      const backendFieldName = fieldsNameMap[fieldName];

      if (user[fieldName] !== '') {
        userToBackend[backendFieldName] = user[fieldName];
      }
    });

    const response = updated ?
      await api.desktop.updateUser(userToBackend) :
      await api.desktop.createUser(userToBackend);

    if (isAuthenticated && !isGuest) {
      dispatch('AUTH_PROFILE');
    }

    return response;
  },
};



// WEBPACK FOOTER //
// ./src/apps/desktop/store/actions.js